import React from 'react';
import { LoadingSpinnerContainer } from '../../../components/atoms/LoadingSpinner';

export function SurveyJSLoadingSpinner() {
  return (
    <div className="survey__container">
      <LoadingSpinnerContainer />
    </div>
  );
}
